import React,{useEffect, useMemo, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import { BsSearch, BsEnvelope, BsBuilding, BsCalendar2Check, BsClock, BsGeoAlt } from "react-icons/bs";
import { RiUserReceivedLine, RiUserSharedLine } from "react-icons/ri";
import { FaPrint } from "react-icons/fa";
import SelectSearch from "../../../../components/ui/SelectSearch";
import { useRemmitances } from "../../../../hooks/useRemmitances";
import NotifyC from "../../../../components/Notifications";
import DataTable from "../../../../components/ui/DataTable";
import { TbZoomReset } from "react-icons/tb";
import { getUser, formatCurrency, sqlDateFormat,  printInvoice  } from "../../../../utils/Common";
import Spinner from "../../../../components/Spinner";
import './index.css'; 
import Swal from "sweetalert2";
import "jspdf-autotable";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TimeRangePicker from 'rsuite/TimeRangePicker';
import CustomProvider  from 'rsuite/CustomProvider';
import * as locales from 'rsuite/locales';
import 'rsuite/TimeRangePicker/styles/index.css';
import './index.css';

const SearchRemittances = () => {
    const user = getUser();
    const { getListOffices, getRemmitancesByFilter, getListStatus, getListProvinces } = useRemmitances();
    const { register, handleSubmit, reset, errors } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [listOffice, setListOffice] = useState([]);
    const [officeSelected, setOfficeSelected] = useState("");
    const [listStatus, setListStatus] = useState([]);
    const [statusSelected, setStatusSelected] = useState("");
    const [originOfficeSelected, setOriginOfficeSelected] = useState("");
    const [listProvinces, setListProvinces] = useState([]);
    const [provinceSelected, setProvinceSelected] = useState("");
    const [dataRemittances, setDataRemittances] = useState(null);
    const [creationDateRange, setCreationDateRange] = useState([null, null]);
    const [startCreationDate, endCreationDate] = creationDateRange;
    const [deliveryDateRange, setDeliveryDateRange] = useState([null, null]);
    const [startDeliveryDate, endDeliveryDate] = deliveryDateRange;
    const [timeCreation, setTimeCreation] = useState([]);
    const [startCreationTime, endCreationTime] = timeCreation;
    const [timeDelivery, setTimeDelivery] = useState([]);
    const [startDeliveryTime, endDeliveryTime] = timeDelivery;
    const data = Object.keys(locales).map(key => ({
        key: key.replace(/([a-z]{2})([A-Z]{2})/, '$1-$2'),
        value: locales[key]
        }));
    const [localeKey, setLocaleKey] = useState('es-ES');
    const locale = data.find(item => item.key === localeKey);
    const contentRef = useRef();

    const formatStatusRemmitances = (value) => {
        switch (value) {
        case 1:
            return 'En proceso'
        case 2:
            return 'Entregado'
        case 3:
            return 'Reintegrado'
        case 4:
            return 'Expirado'
        case 5:
            return 'Entregado luego de expirado'
        case 6:
            return 'Reintegrado luego de expirado'
        default:
            return ''
            }
    }

    const formatTypeRemmitances = (value) => {
        switch (value) {
        case 1:
            return "Postal"
        case 2:
            return "Telegráfica"
        default:
            return ''
        }
    }

      const handlePrintPDF = async (remesa, copyNumber, deliver) => {
        const content = contentRef.current;
      
        if (!content) return;

          const pdfBlob = await printInvoice(remesa, copyNumber, deliver);
            
        if (pdfBlob) {
                const pdfURL = URL.createObjectURL(pdfBlob);
                const iframe = document.createElement("iframe");
                iframe.style.display = "none";
                iframe.src = pdfURL;
                document.body.appendChild(iframe);
            
                iframe.onload = () => {
                  iframe.contentWindow.print();
                };
              }
        
      };

    const confirmCopyPrint = async (message) => {
        const result = await Swal.fire({
          title: message,
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Si",
          cancelButtonText: "No",
          allowOutsideClick: false,
          allowEscapeKey: false,
          customClass: {
            confirmButton: "custom-confirm-button",
            cancelButton: "custom-cancel-button",
        },
        });
        if (result.isConfirmed) {
          return true;
        }
        return false;
    };

    const handlePrintInvoice = async (remesa) => {
        await Swal.fire({
            title: "¿Qué factura deseas imprimir?",
            text: "Selecciona una opción para continuar.",
            icon: "question",
            showCancelButton: true,
            showDenyButton: true,
            confirmButtonText: "Factura de entrega",
            denyButtonText: "Factura de registro",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
                denyButton: "custom-confirm-button",
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (remesa.IdEstatus === 1 || remesa.IdEstatus === 4) {
                    NotifyC.info("No se puede imprimir la factura de entrega porque el giro "  + remesa.IdRemesa + " no ha sido entregado.");
                } else {
                    handlePrintPDF(remesa,2, true);
                    const copyPrintConfirmed = await confirmCopyPrint("¿Desea imprimir una copia de oficinista?");
                    if (copyPrintConfirmed) {
                        handlePrintPDF(remesa,1, true);
                    }
                }
            } else if (result.isDenied) {
                handlePrintPDF(remesa,1, false);
                const copyPrintConfirmed = await confirmCopyPrint("¿Desea imprimir una copia de oficinista?");
                if (copyPrintConfirmed) {
                    handlePrintPDF(remesa,2 , false);
                }
            }
        });
    };

    const columns = useMemo(
        () => {
            const baseColumns = [
                { Header: "Nro. giro", accessor: "IdRemesa", exportable: true },
                { Header: "Estado", accessor: "IdEstatus", Cell: ({ value }) => formatStatusRemmitances(value), exportable: true },
                { Header: "Fecha de registro de giro", id: "fechaC",accessor: "FechaRegistro",Cell: ({ value }) => value ? sqlDateFormat(value, false, true).split('-')[0] : "-", exportable: true },
                { Header: "Hora de registro de giro", id: "horaC",accessor: "FechaRegistro", Cell: ({ value }) => value ? sqlDateFormat(value, false, true).split('-')[1] : "-", exportable: true },
                { Header: "Fecha de entrega", id: "fechaE",accessor: "FechaEmision", Cell: ({ value }) => value ? sqlDateFormat(value, false, true).split('-')[0] : "-", exportable: true },
                { Header: "Hora de entrega", id: "horaE",accessor: "FechaEmision", Cell: ({ value }) => value ? sqlDateFormat(value, false, true).split('-')[1] : "-", exportable: true },
                { Header: "Origen", accessor: "NombreSucursalOrigen", exportable: true  },,
                { Header: "Destino", accessor: "NombreSucursalDestino", exportable: true  },
                { Header: "Remitente", accessor: "NombreCompletoRemitente", Cell: ({ value }) => (value && value.trim() !== "" ? value : "-"), exportable: true  },
                { Header: "Cédula Remitente", accessor: "IdRemitente", Cell: ({ value }) => value ? value.toString() : "-", exportable: true },
                { Header: "Destinatario", accessor: "NombreCompletoDestinatario", Cell: ({ value }) => (value && value.trim() !== "" ? value : "-"), exportable: true  },
                { Header: "Cédula Destinatario", accessor: "IdDestinatario", Cell: ({ value }) => value ? value.toString() : "-", exportable: true  },
                { Header: "Destinatario Secundario", accessor: "NombreCompletoDestinatario2", Cell: ({ value }) => (value && value.trim() !== "" ? value : "-"), exportable: true },
                { Header: "Cédula Destinatario Secundario", accessor: "IdDestinatario2", Cell: ({ value }) => value ? value.toString() : "-", exportable: true  },
                { Header: "Tipo de giro", accessor: "IdTipoRemesa", Cell: ({ value }) => formatTypeRemmitances(value), exportable: true  },
                { Header: "Monto Enviado", accessor: "MontoEnviar", Cell: ({ value }) => formatCurrency(value),exportable: true, isTotalizable: true  },
                { Header: "Comisión por transmisión", accessor: "MontoTransmision", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true },
                { Header: "Comisión por transacción", accessor: "MontoFee", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true,   },
                { Header: "Monto Total", accessor: "MontoTotal", Cell: ({ value }) => formatCurrency(value), exportable: true, isTotalizable: true, },
            ];
            if (user.roleId === 3 || user.roleId === 9) {
                baseColumns.unshift({
                    Header: "Factura",
                    accessor: "Factura",
                    Cell: ({ row }) => (
                        <button
                            className="btn btn-blue"
                            onClick={() => handlePrintInvoice(row.original)}
                        >
                            <FaPrint size={18} />
                        </button>
                    ),
                    exportable: false,
                });
            }
            return baseColumns;
        },
        [user.roleId]
    );

    const exportableColumns = columns.filter(column => column.exportable);

    const renderInput = (field, label, required, type, Icon, placeholder) => (
        <div className="col-12 col-md-6 input-group text-left mb-3">
            <div className="input-group-prepend d-flex align-items-center">
                <span className="input-group-text text-bold input-label" style={{
                backgroundColor: "#FBD825",
                color: "black",
            }}>
                    {Icon && <Icon className="mr-2" size={18} />} {label}
                </span>
            </div>
            <input
                type={type ?? "text"}
                className="form-control input-field"
                name={field}
                ref={register()}
                required={required}
                placeholder={placeholder}
            />
            {errors[field] && (
                <span className="text-danger">{errors[field].message}</span>
            )}
        </div>
    );

    const renderDateTimePicker = (field, label, name, Icon, placeholder, time, setTime, start, end, setDateRange) => (
        <div className="col-12 col-md-6 input-group text-left mb-3 customDatePickerWidth">
            <div className="input-group-prepend d-flex align-items-center">
                <span className="input-group-text text-bold input-label" style={{
                backgroundColor: "#FBD825",
                color: "black",
            }}>
                    {Icon && <Icon className="mr-2" size={18} />} {label}
                </span>
            </div>
                {field === "date" && (
                <DatePicker
                    type="text"
                    selectsRange={true}
                    startDate={start}
                    endDate={end}
                    onChange={(update) => { setDateRange(update);}}
                    name={name}
                    isClearable={true}
                    placeholderText={placeholder}
                    className="form-control input-field"
                    dateFormat="dd/MM/yyyy"
                    style={{ flexGrow: 1, width: "100%", minWidth: "300px" }}
                />
                )}
                {field === "time" && (
                    <CustomProvider locale={locale.value}>
                    <TimeRangePicker 
                        format="hh:mm aa"
                        showMeridiem 
                        className="input-field w-100 "
                        value={time ?? []}
                        onChange={setTime}       
                        placeholder={placeholder}
                        cleanable={true}
                        style={{ fontSize: "20px" }}
                    />
                    </CustomProvider>
                )
                }
            {errors[field] && (
                <span className="text-danger">{errors[field].message}</span>
            )}
        </div>
    );

    const renderSelectOffice = (nameInput, title) => (
        <div className="col-12 col-md-6 input-group text-left mb-3">
            <div className="d-flex w-100">
                <div className="input-group-prepend d-flex align-items-center">
                    <span className="input-group-text text-bold input-label" style={{
                backgroundColor: "#FBD825",
                color: "black",
                borderRadius: "6px 0 0 6px",
            }}><BsBuilding className="mr-2" size={18} /> {title}</span>
            </div>
                <SelectSearch
                    options={listOffice}
                    nameInput={nameInput}
                    setValue={handleSelect}
                    value={officeSelected}
                />
            </div>
        </div>
    );

    const renderSelectStatus = (nameInput, title) => (
        <div className="col-12 col-md-6 input-group text-left mb-3">
            <div className="d-flex w-100">
                <div className="input-group-prepend d-flex align-items-center">
                    <span className="input-group-text text-bold input-label" style={{
                backgroundColor: "#FBD825",
                color: "black",
                borderRadius: "6px 0 0 6px",
            }}><RiUserReceivedLine className="mr-2" size={18} /> {title}</span>
            </div>
                <SelectSearch
                    options={listStatus}
                    nameInput={nameInput}
                    setValue={handleSelect}
                    value={statusSelected}
                />
            </div>
        </div>
    );

    const renderOriginSelectOffice = (nameInput, title) => {
        return (
            <div className="col-12 col-md-6 input-group text-left mb-3">
                <div className="d-flex w-100">
                    <div className="input-group-prepend d-flex align-items-center">
                        <span className="input-group-text text-bold input-label" style={{
                backgroundColor: "#FBD825",
                color: "black",
                borderRadius: "6px 0 0 6px",
              }}><BsBuilding className="mr-2" size={18} /> {title}</span>
            </div>
            <SelectSearch
              options={listOffice}
              nameInput={nameInput}
              setValue={handleSelect}
              value={originOfficeSelected}
            />
          </div>
        </div>
      );
    };

    const renderSelectProvince = (nameInput, title) => (
        <div className="col-12 col-md-6 input-group text-left mb-3">
            <div className="d-flex w-100">
                <div className="input-group-prepend d-flex align-items-center">
                    <span className="input-group-text text-bold input-label" style={{
                backgroundColor: "#FBD825",
                color: "black",
                borderRadius: "6px 0 0 6px",
            }}><BsGeoAlt className="mr-2" size={18} /> {title}</span>
            </div>
                <SelectSearch
                    options={listProvinces}
                    nameInput={nameInput}
                    setValue={handleSelect}
                    value={provinceSelected}
                />
            </div>
        </div>
    );
   
    const resetForm = () => {
        reset();
        setOfficeSelected("");
        setOriginOfficeSelected("");
        setDataRemittances(null);
        setStatusSelected("");
        setProvinceSelected("");
        setCreationDateRange([null, null]);
        setDeliveryDateRange([null, null]);
        setTimeCreation([]);
        setTimeDelivery([]);
    };

    const formatTime = (date) => {
        if (!(date instanceof Date) || isNaN(date)) {
            return null; 
        }
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
    };

    const handleOnSubmit = async (data) => {

        if (user.roleId <= 6 && !officeSelected && !originOfficeSelected) {
            NotifyC.error("Debe seleccionar al menos una estafeta de origen o destino para realizar la búsqueda.", { duration: 4000 });
            return;
        }
        if (user.roleId >= 7 && !officeSelected && !originOfficeSelected && !provinceSelected) {
            NotifyC.error("Debe seleccionar al menos una estafeta de origen, destino o provincia para realizar la búsqueda.", { duration: 4000 });
            return;
        }

         if (
            (startCreationTime || endCreationTime) && 
            (!startCreationDate && !endCreationDate && !startDeliveryDate && !endDeliveryDate)
        ) {
            NotifyC.error("Por favor, seleccione al menos una fecha (de creación o de entrega)", { duration: 4000 });
            return;
        }
        
        if (
            (startDeliveryTime || endDeliveryTime) && 
            (!startCreationDate && !endCreationDate && !startDeliveryDate && !endDeliveryDate)
        ) {
            NotifyC.error("Por favor, seleccione al menos una fecha (de creación o de entrega)", { duration: 4000 });
            return;
        }

        const dataToSend = { 
            ...data, 
             office: officeSelected, 
             originOffice: originOfficeSelected,
             ...(user.roleId >= 7 && { province: provinceSelected }),
             fechaDesdeCreacion: startCreationDate ? startCreationDate: null,
             fechaHastaCreacion: endCreationDate ? endCreationDate : null,
             horaDesdeCreacion: startCreationTime ? formatTime(startCreationTime): null,
             horaHastaCreacion: endCreationTime? formatTime(endCreationTime) : null,
             fechaDesdeEntrega: startDeliveryDate ? startDeliveryDate : null,
             fechaHastaEntrega: endDeliveryDate ? endDeliveryDate : null,
             horaDesdeEntrega: startDeliveryTime ? formatTime(startDeliveryTime): null,
             horaHastaEntrega: endDeliveryTime ? formatTime(endDeliveryTime): null,
             status: statusSelected,
             };
        const hasAnyFieldFilled = Object.values(dataToSend).some(value => value);
        if (!hasAnyFieldFilled) {
            NotifyC.error("Por favor, complete al menos un campo para realizar la búsqueda.", { duration: 4000 });
            return; 
        }
        setIsLoading(true);
        const abortController = new AbortController();
        const response = await getRemmitancesByFilter(abortController.signal, dataToSend);
        if (response?.code === 404) {
            NotifyC.error("No se encontraron giros con los datos ingresados.", { duration: 6000 });     
        }
        if (response?.code === 422) {
            NotifyC.error("El tipo de dato ingresado es incorrecto.", { duration: 6000 });     
        }
        if (response?.code === 500) {
            NotifyC.error("Error interno del servidor, intente nuevamente en unos minutos ", { duration: 6000 });
        }
        if (response?.code === 200) {
            NotifyC.success("("+response.payload.length+") giros encontrados", { duration: 6000 });
            setDataRemittances(response.payload);
        }
        setIsLoading(false);
    };

    const handleGetListOffices = async () => {
        const abortController = new AbortController();
        const response = await getListOffices(abortController.signal);
        if (response.length > 0) {
            if ([1,2,3].includes(user.roleId)) {
                const filteredOffices = response.filter(office => office.value === user.IdEstafeta);
                setListOffice(filteredOffices);
            } else if ([7,8,9].includes(user.roleId)) { 
                setListOffice(response);
            }
            
        } else {
            NotifyC.error("No se encontraron estafetas.", { duration: 6000 });
            setListOffice([]);
        }
    };

    const handleSelect = (name, value) => {
        if (name === "office") {
            setOfficeSelected(value);
        }
        if (name === "originOffice") {
            setOriginOfficeSelected(value);
        }
        if (name === "status") {
            setStatusSelected(value);
        }
        if (name === "province") {
            setProvinceSelected(value);
        }
    };

    const handleGetListStatus = async () => {
        const abortController = new AbortController();
        const response = await getListStatus(abortController.signal);

        if (response.length > 0) {
            setListStatus(response);
        } else {
            NotifyC.error("No se encontraron estados para los giros.", { duration: 6000 });
            setListStatus([]);
        }
    }

    const handleGetListProvinces = async () => {
        const abortController = new AbortController();
        const response = await getListProvinces(abortController.signal);
        if (response.length > 0) {
            setListProvinces(response);
        } else {
            NotifyC.error("No se encontraron provincias.", { duration: 6000 });
            setListProvinces([]);
        }
    }
    
    useEffect(() => {
        handleGetListOffices();
        handleGetListStatus();
        if (user.roleId >= 7) {
            handleGetListProvinces();
        }
      }, []);

    return (
        <>
        <div className="dashboardCard justify-left" style={{ color: "black" }}>
         <div style={{display: "flex", justifyContent:"space-between" }}>
          <div className="d-flex align-items-center" style={{ gap: 15 }}>
            <BsSearch size={25} />
            <h5 className="mb-0">Buscar giros</h5>
            </div>
            {dataRemittances && dataRemittances.length > 0 && (
              <div>
                <button type="reset" className="btn btn-secondary" onClick={resetForm}><TbZoomReset size={20}/> Reiniciar</button>
            </div>
            )}
         </div> 
        </div>
        {!dataRemittances && (
          <div className="dashboardCard">
             <p style={{color: "#6C757D", fontSize: "16px", marginBottom: "20px", textAlign: "start",
            }}>Ingrese la información del giro que desea buscar:</p>
            <form onSubmit={handleSubmit(handleOnSubmit)}>
             <div className="row">
               {renderInput( "sender", "Remitente", false, "text", RiUserSharedLine, "Nombre | apellido | cédula o pasaporte | email")}
               {renderDateTimePicker("date","Fecha de creación","dateRangeC",BsCalendar2Check,"Seleccionar rango de fechas",null, null, startCreationDate,endCreationDate,setCreationDateRange)}
               {renderInput( "numRemittance", "No. de giro", false, "number", BsSearch)}
               {renderDateTimePicker( "time", "Hora de creación", null, BsClock, "Seleccionar rango de horas",timeCreation, setTimeCreation, null, null, null)}
               {renderInput( "recipient", "Destinatario", false, "text", RiUserReceivedLine, "Nombre | apellido | cédula o pasaporte | email")}
               {renderDateTimePicker("date","Fecha de Entrega","dateRangeE",BsCalendar2Check,"Seleccionar rango de fechas",null, null,startDeliveryDate,endDeliveryDate,setDeliveryDateRange)}
               {renderInput( "pin", "Ingresar PIN", false, "number", BsEnvelope)}
               {renderDateTimePicker( "time", "Hora de Entrega", null, BsClock, "Seleccionar rango de horas", timeDelivery, setTimeDelivery, null, null, null)}
               {renderOriginSelectOffice("originOffice", "Estafeta de origen")}
               {renderSelectOffice("office", "Estafeta de destino")}
               {user.roleId >= 7 && renderSelectProvince("province", "Provincia")}
               {renderSelectStatus("status", "Estado")}
            </div>
            <div className="d-flex justify-content-center mt-3" style={{gap:"12px"}}>
                {isLoading ? (
                        <button type="submit" className="btn btn-blue" disabled><Spinner type={1} size={15} /> Buscar</button>
                ) : (
                    <button type="submit" className="btn btn-blue"><BsSearch /> Buscar</button>
                )}
                <button type="reset" className="btn btn-secondary" onClick={resetForm}><TbZoomReset size={20}/> Reiniciar</button>
            </div>
            </form>
        </div>
        )
        }
        {dataRemittances && dataRemittances.length > 0 && (
                <div className="dashboardCard mt-3">
                    <DataTable
                        columns={columns}
                        data={dataRemittances}
                        tableTitle="Resultados de Giros"
                        filename="giros-cotel"
                        exportExcel
                        exportPdf
                        exportableColumns={exportableColumns}
                        nameReport='REPORTE GIROS'
                        col={+2.4-1.26}
                        row={0}
                        includeTotals={true}
                        logTypeExcel={8}
                        logTypePdf={12}
                    />
                </div>
            )}
                 <div ref={contentRef}>
      </div>
        </>
    );
    };
    export default SearchRemittances;
